import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';

export default function ProposalBusiness(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;
    let isReadOnly = decode.readOnly;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [readOnly, setReadOnly] = React.useState(false);

    let refCompanyName = React.useRef();
    let refCompanyType = React.useRef();
    let refCompanyProduct = React.useRef();
    let refAddressNo = React.useRef();
    let refRoad = React.useRef();
    let refSubDistrict = React.useRef();
    let refDistrict = React.useRef();
    let refProvince = React.useRef();
    let refZipcode = React.useRef();
    let refEmail = React.useRef();
    let refPhone = React.useRef();
    let refFax = React.useRef();
    let refContactName = React.useRef();
    let refCompanyRegister = React.useRef();
    let refCompanyNumber = React.useRef();
    let refCompanyCapital = React.useRef();
    let refCompanyPerShare = React.useRef();
    let refCompanyShareCount = React.useRef();
    let refCompanySharePaid = React.useRef();
    let refCompanySharePaidCount = React.useRef();
    let refCompanyShareDate = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if ([Utils.PROPOSAL_STATUS_APPROVE].includes(resDetail.status)) {
                        setReadOnly(true);
                    }

                    if(isReadOnly) {
                        setReadOnly(isReadOnly);
                    }

                    if (prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }
                }

                const resData = await getData(); 

                if(resData) {
                    refCompanyName.current.value = resData.companyName;
                    refCompanyType.current.value = resData.companyType;
                    refCompanyProduct.current.value = resData.companyProduct;
                    refAddressNo.current.value = resData.addressNo;
                    refRoad.current.value = resData.road;
                    refSubDistrict.current.value = resData.subDistrict;
                    refDistrict.current.value = resData.district;
                    refProvince.current.value = resData.province;
                    refZipcode.current.value = resData.zipcode;
                    refEmail.current.value = resData.email;
                    refPhone.current.value = resData.phone;
                    refFax.current.value = resData.fax;
                    refContactName.current.value = resData.contactName;
                    refCompanyRegister.current.value = resData.companyRegister;
                    refCompanyNumber.current.value = resData.companyNumber;
                    refCompanyCapital.current.value = resData.companyCapital;
                    refCompanyPerShare.current.value = resData.companyPerShare;
                    refCompanyShareCount.current.value = resData.companyShareCount;
                    refCompanySharePaid.current.value = resData.companySharePaid;
                    refCompanySharePaidCount.current.value = resData.companySharePaidCount;
                    refCompanyShareDate.current.value = resData.companyShareDate;
                }

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getData() {
        const response = await fetch(Config.apiUrl +'/proposalBusiness/viewBusiness', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        //if(readOnly) {
        //    navigate((prop.lang === 'en' ? '/en':'') + '/proposalApprove');
        //}
        //else {
        navigate((prop.lang === 'en' ? '/en':'') + '/proposal');
        //}
    };

    const onSubmit = async () => {
        let companyName = refCompanyName.current.value;
        let companyType = refCompanyType.current.value;
        let companyProduct = refCompanyProduct.current.value;
        let addressNo = refAddressNo.current.value;
        let road = refRoad.current.value;
        let subDistrict = refSubDistrict.current.value;
        let district = refDistrict.current.value;
        let province = refProvince.current.value;
        let zipcode = refZipcode.current.value;
        let email = refEmail.current.value;
        let phone = refPhone.current.value;
        let fax = refFax.current.value;
        let contactName = refContactName.current.value;
        let companyRegister = refCompanyRegister.current.value;
        let companyNumber = refCompanyNumber.current.value;
        let companyCapital = refCompanyCapital.current.value;
        let companyPerShare = refCompanyPerShare.current.value;
        let companyShareCount = refCompanyShareCount.current.value;
        let companySharePaid = refCompanySharePaid.current.value;
        let companySharePaidCount = refCompanySharePaidCount.current.value;
        let companyShareDate = refCompanyShareDate.current.value;

        if(companyName === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Company Name':'กรุณาระบุ ชื่อบริษัท');
            refCompanyName.current.focus();
        }
        else if(companyType === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Business Type':'กรุณาระบุ ประเภทธุรกิจ');
            refCompanyType.current.focus();
        }
        else if(companyProduct === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Product, service or process':'กรุณาระบุ ผลิตภัณฑ์ บริการหรือกระบวนการ');
            refCompanyProduct.current.focus();
        }
        else if(addressNo === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Address':'กรุณาระบุ เลขที่');
            refAddressNo.current.focus();
        }
        else if(subDistrict === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Sub District':'กรุณาระบุ แขวง/ตำบล');
            refSubDistrict.current.focus();
        }
        else if(district === '') {
            toast.error(prop.lang === 'en' ? 'Please specify District':'กรุณาระบุ เขต/อำเภอ');
            refDistrict.current.focus();
        }
        else if(province === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Province':'กรุณาระบุ จังหวัด');
            refProvince.current.focus();
        }
        else if(zipcode === '' || isNaN(zipcode) || zipcode.length !== 5) {
            toast.error(prop.lang === 'en' ? 'Please specify Sub District':'กรุณาระบุ รหัสไปรษณีย์ ตัวเลข 5 หลัก');
            refZipcode.current.focus();
        }
        else if(email === '' || !Utils.validateEmail.test(email)) {
            toast.error(prop.lang === 'en' ? 'Please specify a valid email':'กรุณาระบุ รูปแบบอีเมลให้ถูกต้อง');
            refEmail.current.focus();
        }
        else if(phone === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Phone number.':'กรุณาระบุ ระบุเบอร์โทรศัพท์');
            refPhone.current.focus();
        }
        else if(contactName === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Contact Name':'กรุณาระบุ ชื่อผู้ติดต่อ');
            refContactName.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                proposalId: proposalId,
                                companyName: companyName.trim(),
                                companyType: companyType.trim(),
                                companyProduct: companyProduct.trim(),
                                addressNo: addressNo.trim(),
                                road: road.trim(),
                                subDistrict: subDistrict.trim(),
                                district: district.trim(),
                                province: province.trim(),
                                zipcode: zipcode.trim(),
                                phone: phone.trim(),
                                email: email.trim(),
                                fax: fax?.trim(),
                                contactName: contactName.trim(),
                                companyRegister: companyRegister?.trim(),
                                companyNumber: companyNumber?.trim(),
                                companyCapital: companyCapital?.trim(),
                                companyPerShare: companyPerShare?.trim(),
                                companyShareCount: companyShareCount?.trim(),
                                companySharePaid: companySharePaid?.trim(),
                                companySharePaidCount: companySharePaidCount?.trim(),
                                companyShareDate: companyShareDate?.trim(),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateBusiness(param);

                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Information about the business model has been recorded successfully.':'อัพเดตข้อมูลเกี่ยวกับรูปแบบธุรกิจ เรียบร้อย');
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function updateBusiness(param) {
        const response = await fetch(Config.apiUrl +'/proposalBusiness/update', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.scholarship.title_en : detail?.scholarship.title}</h3>

                                <h3 className="title-bar mt-4 mb-2">{prop.lang === 'en' ? 'Part 4 Business Operator Information':'ส่วนที่ 4 ข้อมูลผู้ประกอบการ'}</h3>
                                <h4 className="title-line-left mb-2">1. {prop.lang === 'en' ? 'Information about the business model (if it is a Startup or Spinoff Company)':'ข้อมูลเกี่ยวกับรูปแบบธุรกิจ (หากเป็นกรณี Startup หรือ Spinoff Company)'}</h4>
                                <div className="row g-4 mt-2">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Company Name':'ชื่อบริษัท'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refCompanyName} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Business Type':'ประเภทธุรกิจ'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refCompanyType} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Product, service or process':'ผลิตภัณฑ์ บริการหรือกระบวนการ'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refCompanyProduct} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mb-2 mt-5">2. {prop.lang === 'en' ? 'Office Location':'ที่ตั้งสำนักงาน'}</h4>
                                <div className="row g-4 mt-2">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Address':'เลขที่'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refAddressNo} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Road':'ถนน'} </h6>
                                            <input type="text" className="form-control" ref={refRoad} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Sub District':'แขวง/ตำบล'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refSubDistrict} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'District':'เขต/อำเภอ'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refDistrict} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Province':'จังหวัด'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refProvince} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Zipcode':'รหัสไปรษณีย์'} <span className="star">*</span></h6>
                                            <input type="number" className="form-control" ref={refZipcode} maxLength={5} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Phone':'เบอร์โทร'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refPhone} maxLength={10} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Fax':'โทรสาร'}</h6>
                                            <input type="text" className="form-control" ref={refFax} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Email':'อีเมล'} <span className="star">*</span></h6>
                                            <input type="text" className="form-control" ref={refEmail} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Contact Name':'ชื่อผู้ติดต่อ'}</h6>
                                            <input type="text" className="form-control" ref={refContactName} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Company Register Date':'วันจดทะเบียนก่อตั้ง'}</h6>
                                            <input type="text" className="form-control" ref={refCompanyRegister} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Company Register Number':'ทะเบียนเลขที่'}</h6>
                                            <input type="text" className="form-control" ref={refCompanyNumber} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Registered Capital (THB)':'ทุนจดทะเบียน (บาท)'}</h6>
                                            <input type="number" className="form-control" ref={refCompanyCapital} maxLength={20} disabled={readOnly} />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Registered capital, par value per share (THB)':'ทุนจดทะเบียน มูลค่าหุ้นละ (บาท)'}</h6>
                                            <div className="input-group">
                                                <input type="number" className="form-control" ref={refCompanyPerShare} maxLength={20} disabled={readOnly} />
                                                <div className="input-group-text">{prop.lang === 'en' ? 'Number of ':'จำนวน (หุ้น)'}</div>
                                                <input type="number" className="form-control" ref={refCompanyShareCount} maxLength={11} disabled={readOnly} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Paid-up registered capital (THB)':'ทุนจดทะเบียนที่เรียกชำระแล้ว (บาท)'}</h6>
                                            <div className="input-group">
                                                <input type="number" className="form-control" ref={refCompanySharePaid} maxLength={20} disabled={readOnly} />
                                                <div className="input-group-text">{prop.lang === 'en' ? 'Number of ':'จำนวน (หุ้น)'}</div>
                                                <input type="number" className="form-control" ref={refCompanySharePaidCount} maxLength={11} disabled={readOnly} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Paid Date':'วันที่ชำระ'}</h6>
                                            <input type="text" className="form-control" ref={refCompanyShareDate} maxLength={250} disabled={readOnly} />
                                        </div>
                                    </div>
                                </div>

                                <div className="py-3"><hr /></div>
                                <div className="buttons gap-15 py-0 mb-4">
                                    <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                    {
                                        !readOnly ? <button className="btn btn-secondary w-130" type="button" onClick={onSubmit}>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</button> : ''
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 